export default __webpack_public_path__ + "static/media/ui_lock.7e384d94.ogg";